import { render, staticRenderFns } from "./NotesProjectContainer.vue?vue&type=template&id=308f6782&scoped=true&"
import script from "./NotesProjectContainer.vue?vue&type=script&lang=js&"
export * from "./NotesProjectContainer.vue?vue&type=script&lang=js&"
import style0 from "./NotesProjectContainer.vue?vue&type=style&index=0&id=308f6782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308f6782",
  null
  
)

export default component.exports